import { useMutation } from "@tanstack/react-query";

import { toast } from "react-toastify";

import { refreshNowApiCall, updateEnrollNowApiCall } from "./utils.api";

export const useUpdateEnrollNow = () =>
  useMutation({
    mutationFn: (body) => updateEnrollNowApiCall(body),
    onError: (error) => {
      const errorMessage =
        error instanceof Error ? error.message : "Enrollment failed";

      toast.error(errorMessage);
    },
  });

export const useRefreshNow = () =>
  useMutation({
    mutationFn: () => refreshNowApiCall(),
    onError: (error) => {
      const errorMessage =
        error instanceof Error ? error.message : "Enrollment failed";

      toast.error(errorMessage);
    },
  });
